import reducer from "./reducer";
export { default as IssueSummary } from "./components/index";
export { default as issueSummaryReducerName } from "./constants";
export default reducer;
